export interface Category {
  id: string;
  name: string;
  en: string;
  tagline: string;
  desc: string;
  cover: string;
  accent: string;
}

export const categories: Category[] = [
  {
    id: "chuntian",
    name: "纯爱甜宠",
    en: "Sweet Love",
    tagline: "甜度爆表的双向奔赴",
    desc: "没有复杂误会，只有双向奔赴的怦然心动。全程高甜无虐，脸红心跳不断线。",
    cover:
      "https://readdy.ai/api/search-image?query=Cute%20anime%20manga%20cover%20of%20a%20blushing%20boy%20and%20girl%20holding%20hands%20under%20blooming%20pink%20cherry%20blossoms%2C%20warm%20peach%20sunset%20glow%2C%20soft%20romantic%20atmosphere%2C%20clean%20vibrant%20illustration%20style%2C%20heartfelt%20sweet%20vibe&width=600&height=800&seq=cat-chuntian-01&orientation=portrait",
    accent: "#ff4d6d",
  },
  {
    id: "anlian",
    name: "暗恋心事",
    en: "Secret Crush",
    tagline: "不敢说出口的喜欢",
    desc: "藏在课本、纸条和偷看眼神里的秘密。心跳加速的每一刻，都是青春最好的注脚。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20shy%20schoolgirl%20hiding%20a%20love%20letter%20behind%20her%20back%2C%20blushing%20cheeks%2C%20soft%20classroom%20window%20light%2C%20warm%20pastel%20pink%20and%20cream%20tone%2C%20gentle%20romantic%20illustration%20style&width=600&height=800&seq=cat-anlian-01&orientation=portrait",
    accent: "#ff7f1a",
  },
  {
    id: "yuanjia",
    name: "冤家拉扯",
    en: "Rival Push-pull",
    tagline: "针锋相对又悄悄心动",
    desc: "嘴上针锋相对，心里小鹿乱撞。相爱相杀的拉扯桥段，甜虐交织最上头。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20teasing%20boy%20and%20girl%20arguing%20face%20to%20face%2C%20playful%20banter%2C%20warm%20coral%20and%20rose%20tone%2C%20electric%20romantic%20tension%2C%20clean%20vibrant%20illustration%20style&width=600&height=800&seq=cat-yuanjia-01&orientation=portrait",
    accent: "#d5536d",
  },
  {
    id: "qiyue",
    name: "契约恋爱",
    en: "Contract Love",
    tagline: "假恋爱？真心动！",
    desc: "一纸契约开始的恋爱，从各取所需到假戏真做。界限被一点点打破的拉扯最动人。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20contract%20with%20a%20pen%20and%20two%20romantic%20characters%20silhouette%20holding%20it%2C%20warm%20peach%20and%20gold%20light%2C%20stylish%20romantic%20illustration%2C%20elegant%20modern%20clean%20style&width=600&height=800&seq=cat-qiyue-01&orientation=portrait",
    accent: "#f0630a",
  },
  {
    id: "zhichang",
    name: "职场暧昧",
    en: "Office Romance",
    tagline: "办公桌旁的心跳加速",
    desc: "并肩工作的默契与若即若离的试探。职业装下的心动，克制又汹涌。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20a%20mature%20office%20couple%20in%20smart%20attire%20leaning%20close%20at%20a%20modern%20desk%2C%20warm%20amber%20office%20lighting%2C%20romantic%20tension%2C%20clean%20stylish%20illustration%20style&width=600&height=800&seq=cat-zhichang-01&orientation=portrait",
    accent: "#cd7c55",
  },
  {
    id: "xiaoyuan",
    name: "校园心动",
    en: "Campus Heartbeat",
    tagline: "青春里的怦然时刻",
    desc: "教室、操场、放学路上，每一个平凡的校园瞬间，都藏着让人脸红的喜欢。",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20school%20students%20walking%20home%20together%20under%20golden%20afternoon%20sun%2C%20warm%20peach%20sky%2C%20innocent%20youthful%20romance%2C%20clean%20vibrant%20illustration%20style&width=600&height=800&seq=cat-xiaoyuan-01&orientation=portrait",
    accent: "#e47d90",
  },
];